export const SET_ERROR = 'setError';
export const CLEAR_ERRORS = 'clearErrors';

export const SET_AUTH = "setUser";
export const RESET_AUTH = "logout";

export const SET_AUTH_DIALOG = 'setAuthDialog';
export const SET_CURRENT_FORM = 'setCurrentForm';

export const CLEAR_EVENTS = 'clearEvents';
export const SET_EVENTS = 'setEvents';

export const RESET_OPTIONS = 'resetOptions';
export const SET_OPTIONS = 'setOption';
export const SET_SELECTED_OPTIONS = 'setSelectedOptions';

export const SET_LEAGUES = 'setLeagues';
export const SET_SELECTED_LEAGUES = 'setSelectedLeagues';

export const SET_ADDONS = 'setAddons';
export const SET_SELECTED_ADDONS = 'setSelectedAddons';

export const SET_TEAMS = 'setTeams';
export const SET_SELECTED_TEAMS = 'setSelectedTeams';

export const CLEAR_GROUPS = 'clearGroups';
export const SET_GROUPS = 'setGroups';

export const APPEND_GROUP = 'appendGroup';
export const SET_GROUP = 'setGroup';
export const REMOVE_GROUP = 'removeGroup';

export const APPEND_SCREEN = 'appendScreen';
export const SET_SCREEN = 'setScreen';
export const REMOVE_SCREEN = 'removeScreen';

export const CLEAR_SCHEDULE = 'clearSchedules';
export const SET_SCHEDULE = 'setSchedules';

export const SET_FAVORITES = 'setFavorites';
export const SET_PREFERRED = 'setPreferred';